import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    signal
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-service-unavailable',
    templateUrl: './service-unavailable.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule],
})
export class ServiceUnavailableComponent implements OnDestroy {
    readonly countdown = signal<number>(0);
    readonly isTimerActive = signal<boolean>(false);

    private timerInterval: ReturnType<typeof setInterval> | null = null;

    tryAgain(): void {
        this.startCountdown();
    }

    private startCountdown(counterTime = 3): void {
        this.countdown.set(counterTime);
        this.isTimerActive.set(true);

        this.timerInterval = setInterval(() => {
            const next = this.countdown() - 1;
            if (next <= 0) {
                this.retry();
            } else {
                this.countdown.set(next);
            }
        }, 1000);
    }

    private retry(): void {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        this.isTimerActive.set(false);
        this.countdown.set(0);
        window.location.href = '/';
    }

    ngOnDestroy(): void {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }
}
